export enum OilStoreQueryKeys {
  GET_OIL_STORES = 'GET_OIL_STORES',
  GET_OIL_STORE_DETAIL = 'GET_OIL_STORE_DETAIL',
  GET_OIL_STORE_TRANSACTIONS = 'GET_OIL_STORE_TRANSACTIONS',
  EXPORT_OIL_STORE_TRANSACTIONS = 'EXPORT_OIL_STORE_TRANSACTIONS',
}
